import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../components/ui/use-toast";
import { fetch } from "./fetch";

const updateBookingAcceptCardPayments = async (bookingId: string, acceptCardPayments: boolean) => {
  return fetch(`/api/bookings/${bookingId}/accept-card-payments`, "PATCH", { acceptCardPayments });
};

export const useBookingAcceptCardPaymentsMutation = (bookingId: string) => {
  const queryClient = useQueryClient();
  const { toast, dismiss } = useToast();

  return useMutation({
    mutationFn: (data: { acceptCardPayments: boolean; toastId: any }) =>
      updateBookingAcceptCardPayments(bookingId, data.acceptCardPayments),
    onSuccess: (_, variables) => {
      dismiss(variables.toastId);

      toast({
        title: "Success",
        description: "Accept card payments section updated!",
        variant: "default",
      });

      queryClient.invalidateQueries({ queryKey: ["bookingYachtOfferData", bookingId] });
    },
    onError: (error: any, variables) => {
      dismiss(variables.toastId);
      toast({
        title: "Error",
        description: error.message || "Failed to update accept card payments section!",
        variant: "destructive",
      });
    },
  });
};
